// Function loadSiteHeaderWoolLab loads the SiteHeaderWoolLab class by dynamically importing the js on demand if needed

export function loadSiteHeaderWoolLab($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="SiteHeaderWoolLab"]');

	if(!$wg) {
		// console.info('SiteHeaderWoolLab: no widget found');
		return Promise.reject('SiteHeaderWoolLab widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-site-header-chunk" */ '../widgets/siteHeaderWoolLab').then(wg => {

		const { SiteHeaderWoolLab } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="SiteHeaderWoolLab"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new SiteHeaderWoolLab($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new SiteHeaderWoolLab($wg);
		}


	}).catch(error => error+'An error occurred while loading the SiteHeaderWoolLab widget');

}
